import httpClient from '../httpClient';

const createQuestion = async (data) => {
  return await httpClient.post(`question/`, data);
};

const updateQuestion = async (id, data) => {
  return await httpClient.put(`question/${id}/`, data);
};

const deleteQuestion = async (id) => {
  return await httpClient.delete(`question/${id}/`);
};

const queryQuestions = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/question/?page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
    { params: query },
  );
};

const queryQuestionsExpanded = async (query = {}) => {
  return await httpClient.get(`/question/expanded`, { params: query });
};

const queryQuestionsGridFields = async (query = {}) => {
  return await httpClient.get(`/question/grid_fields`, { params: query });
}

const queryQuestionsGridValues = async (query = {}) => {
  return await httpClient.get(`/question/grid_values`, { params: query });
}

const questionSetOrder = async (id, data) => {
  return await httpClient.post(`question/${id}/set_order/`, data);
};

export {
  createQuestion,
  updateQuestion,
  deleteQuestion,
  queryQuestions,
  queryQuestionsExpanded,
  queryQuestionsGridFields,
  queryQuestionsGridValues,
  questionSetOrder,
}
